import React, { useEffect, useState } from 'react';
import { CalendarClock } from 'lucide-react';
import api from '../api';

// Patients whose current 60-day certification period ends within `days`
export const useCertEndingSoon = (days = 5) => {
  const [map, setMap] = useState({});
  useEffect(() => {
    api.get(`/cert-periods/ending-soon?days=${days}`).then(r => setMap(r.data.patients || {})).catch(() => setMap({}));
  }, [days]);
  return map;
};

export const CertEndingBadge = ({ info, patientId }) => {
  if (!info) return null;
  const when = info.daysLeft === 0 ? 'ends today' : `ends in ${info.daysLeft} day${info.daysLeft === 1 ? '' : 's'}`;
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-red-600 text-white text-[11px] font-semibold"
      title={`Certification period ends ${info.end}`} data-testid={`cert-ending-badge-${patientId}`}>
      <CalendarClock className="w-3 h-3" /> Cert {when}
    </span>
  );
};
